import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const roleHome = (role) => role === "AMMINISTRATORE" ? "/admin" : role === "UFFICIO" ? "/ufficio" : "/lavoratore";

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.profilo_accesso !== role) {
    return <Navigate to={roleHome(user.profilo_accesso)} replace />;
  }
  return children;
}
